import { REQUEST_TYPE_NAMES, REQUEST_TYPE_VALUES, TOOL_NAMES, TOOL_VALUES } from "constants/selects.content";

export const isToolName = (name: string): name is TOOL_NAMES => name in TOOL_VALUES;

export const isRequestTypeName = (name: string): name is REQUEST_TYPE_NAMES => name in REQUEST_TYPE_VALUES;
